// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivacyPolicyMain_wrapper__XEILU","title":"PrivacyPolicyMain_title__OAV8Z","line":"PrivacyPolicyMain_line__u46ge"};